import { Component, ViewChild, AfterViewInit, ElementRef, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
import { LlModelsService } from '../ll-models.service';

@Component({
  selector: 'll-model-info',
  templateUrl: './ll-model-info.component.html',
  styleUrls: ['../cssMain.css']
})
export class LlModelInfoComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('mainDiv_ll_model_info') mainDiv!: ElementRef<HTMLDivElement>;

  bundle = {
    action: '',
    showDisplay: false,
    canEdit: false,
    sysAdmin: false,
    disabled: true,
    showARSettings: false,

    MODEL: null as any,
    LEAD_LENDERS: [] as any[],
    COMPANYLIST: [] as any[],
    PRODUCTS: [] as any[],

    parentW: 0,
    parentH: 0,
    spX: 20,
    spY: 30,
    spW: 0,
    spH: 0,
  };

  constructor(
    private llModelsService: LlModelsService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.loadData();
  }

  ngAfterViewInit(): void {
    this.calculateDimensions();
  }

  ngOnDestroy(): void { }

  private calculateDimensions(): void {
    const parent = this.mainDiv.nativeElement.parentElement?.parentElement;
    if (!parent) return;

    this.bundle.parentW = parent.clientWidth;
    this.bundle.parentH = parent.clientHeight;
    this.bundle.spW = this.bundle.parentW - (this.bundle.spX * 2);
    this.bundle.spH = this.bundle.parentH - this.bundle.spY - 40;

    this.cdr.detectChanges();
  }

  private loadData(): void {
    this.llModelsService.NG_LL_company_model_get((modelData: any) => {
      if (Array.isArray(modelData) && modelData.length > 0) {
        this.bundle.MODEL = modelData[0];
      } else if (modelData && !Array.isArray(modelData)) {
        this.bundle.MODEL = modelData;
      } else {
        this.bundle.MODEL = null;
      }

      ///console.log('modelData:', modelData);
      this.cdr.detectChanges();

      this.llModelsService.NG_LL_model_AR_leadLenders_get((leadLenders: any[]) => {
        this.bundle.LEAD_LENDERS = leadLenders || [];

        //let topRecord = {
        //  LEADLENDERCOMPANYID: 0,
        //  COMPANYNAME: 'Not Asssigned'
        //}

        //this.bundle.LEAD_LENDERS.unshift(topRecord)

        ///console.log('Lead Lenders:', leadLenders);
        this.cdr.detectChanges();

        this.llModelsService.NG_LL_model_AR_modelCompanies_picklist_get((companyList: any[]) => {
          this.bundle.COMPANYLIST = companyList || [];

          //console.log(this.bundle.COMPANYLIST);

          this.llModelsService.NG_LL_company_products_get((products: any[]) => {
            this.bundle.PRODUCTS = products || [];
           
            this.cdr.detectChanges();
          });
        });
      });
    });
  }

  onStatusChange(newStatus: 'A' | 'N' | 'P'): void {
    if (this.bundle.MODEL) {
      this.bundle.MODEL.STATUS = newStatus;
      console.log('Model STATUS updated to:', newStatus);

      this.llModelsService.NG_LL_company_model_edit('STATUS', newStatus)
      this.cdr.detectChanges();
    }
  }

  onLenderChange(event: any): void {
    const newCompanyId = event.target.value;
    if (this.bundle.MODEL) {
      this.bundle.MODEL.LEADLENDERCOMPANYID = newCompanyId;
      this.llModelsService.NG_LL_company_model_edit('LEADLENDERCOMPANYID', newCompanyId)
      this.loadData();

      console.log('Lead Lender updated to COMPANYID:', newCompanyId);
    }
  }

  onModelNameChange(event: any): void {
    const newName = event.target.value;
    if (this.bundle.MODEL) {
      this.bundle.MODEL.MODELNAME = newName;
      console.log('Model NAME updated to:', newName);
    }
  }

  onProductSelectedChange(product: any): void {
    product.SELECTED = !product.SELECTED;
    console.log('Product SELECTED updated:', product.SYSTEMPRODUCTNAME, product.SELECTED);
    this.cdr.detectChanges();
  }

  formatPrice(value: any): string {
    const num = parseFloat(value);
    return isNaN(num) ? '' : num.toLocaleString('en-US', { minimumFractionDigits: 0 });
  }

  onProductPriceChange(product: any, event: any): void {
    let input = event.target.value.replace(/,/g, '');

    if (input === '' || /^\d*\.?\d*$/.test(input)) {
      const numValue = input === '' ? null : parseFloat(input);
      product.SYSTEMPRODUCTPRICE = numValue;
      ///console.log('Product PRICE updated:', product.SYSTEMPRODUCTNAME, numValue);
      event.target.value = this.formatPrice(numValue);
      this.cdr.detectChanges();
    } else {
      event.target.value = this.formatPrice(product.SYSTEMPRODUCTPRICE);
    }
  }

  /** Computed total of selected products */
  get totalSelectedAmount(): number {
    if (!this.bundle.PRODUCTS || this.bundle.PRODUCTS.length === 0) return 0;

    return this.bundle.PRODUCTS
      .filter(p => p.SELECTED === true)
      .reduce((sum, p) => {
        const price = parseFloat(p.SYSTEMPRODUCTPRICE);
        return sum + (isNaN(price) ? 0 : price);
      }, 0);
  }

  onCompanySelectedChange(company: any): void {
    company.SELECTED = company.SELECTED === 'Yes' ? 'No' : 'Yes';

    let action = 'edit'

    if (company.SELECTED === 'No') {
      action = 'remove'
    }

    console.log(company.SELECTED + " - " + action)

    this.llModelsService.NG_LL_model_AR_modelCompanies_picklist_edit(company, action)
    ///this.loadData();


    ///console.log('Company SELECTED updated:', company.COMPANYNAME, company.SELECTED);
    this.cdr.detectChanges();
  }

  onCompanyPercentageChange(company: any, event: any): void {
    let input = event.target.value.replace(/[^0-9.]/g, '');   // allow only numbers + decimal
    // keep only the first decimal point
    const parts = input.split('.');
    if (parts.length > 2) {
      input = parts[0] + '.' + parts.slice(1).join('');
    }
    company.PERCENTAGE = input === '' ? null : input;
    event.target.value = input;
    ///console.log('Company PERCENTAGE updated:', company.COMPANYNAME, company.PERCENTAGE);
    this.cdr.detectChanges();
  }

  onSave(): void {
    console.log('Save clicked');
    // TODO: call your save service methods here
    // e.g. this.llModelsService.NG_LL_..._save(...)
  }
}
